import { PropertyTypes } from "epsm-api-types";
import { formatValue } from "@/components/widgets/helpers/FormattingHelpers";
import { getStartOfCurrentWeek } from "../getStartOfCurrentWeek";

export const generateWeekdayFilters = (
	offset = 0,
): {
	label: string;
	start: number;
	end: number;
}[] => {
	const monday = getStartOfCurrentWeek(offset);

	const utcYear = monday.getUTCFullYear();
	const utcMonth = monday.getUTCMonth();
	const utcDate = monday.getUTCDate();

	return Array.from({ length: 5 }, (_, i) => {
		const start = new Date(
			Date.UTC(utcYear, utcMonth, utcDate + i, 0, 0, 0, 0),
		);
		const end = new Date(
			Date.UTC(utcYear, utcMonth, utcDate + i + 1, 0, 0, 0, 0),
		);

		return {
			label: formatValue(start, PropertyTypes.DATE, {
				weekday: "short",
				month: "short",
				day: "numeric",
				year: "numeric",
			}),
			start: start.getTime(),
			end: end.getTime(),
		};
	});
};
